import StorageService from 'services/StorageService';

const refreshTokenStorage = new StorageService(process.env.REACT_APP_REFRESH_TOKEN_NAME, { string: true });

export default refreshTokenStorage;
